import CompanyRole from "./CompanyRole.js";

/**
 * `companyAdminRole` describes permissions of a company admin over
 * other users.
 */
export default class CompanyAdminRole extends CompanyRole {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByCompanyAdmin(this));
	}

	canAttachOrDetachCompanyId(user, companyId) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByCompanyAdmin(
					this,
					companyId,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByCompanyAdmin(this));
	}

	canViewBudgetEditor(company) {
		return this.canViewAccountingDocuments(company);
	}

	canCreatePeriodReports(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}
}
